'use strict';

import { init } from './controllers/initTable';

init();
